<app-pan-modal #newKioskProviderModal [topLevel]="false" [shouldBodyScroll]="false" size="sm">
  <div header>Add New Kiosk Provider</div>
  <div body>
    <app-pan-form-control>
      <div class="relative mb-6">
        <app-pan-floating-label>Data Source</app-pan-floating-label>
        <ng-select
          class="w-full"
          placeholder="Select a data source..."
          [items]="dataSources()"
          [(ngModel)]="selectedDataSource"
          (ngModelChange)="selectedKioskProvider.set(undefined)"
        >
          <ng-template ng-label-tmp let-dataSource="item"> {{ dataSource }} </ng-template>

          <ng-template ng-option-tmp let-dataSource="item"> {{ dataSource }} </ng-template>
        </ng-select>
      </div>
      <div class="relative mb-6">
        <app-pan-floating-label>Kiosk Provider</app-pan-floating-label>
        <ng-select
          class="w-full"
          bindLabel="alias"
          placeholder="Select kiosk provider..."
          [items]="filteredKioskProviders()"
          [ngModel]="selectedKioskProvider()"
          (ngModelChange)="onSelectProvider($event)"
          [addTag]="true"
          addTagText="Add new kiosk provider"
        >
          <ng-template ng-label-tmp let-item="item"> {{ item.alias }} ({{ item.data_source }} - {{ item.external_id }}) </ng-template>

          <ng-template ng-option-tmp let-item="item"> {{ item.alias }} ({{ item.data_source }} - {{ item.external_id }}) </ng-template>
        </ng-select>
      </div>
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button panModalClose color="primary" (click)="addKioskProvider()" [disabled]="!selectedKioskProvider()"
      >Add Kiosk Provider</app-pan-button
    >
  </div>
</app-pan-modal>

<app-pan-section-header class="mt-4" title="Kiosk Organizations">
  <app-pan-button
    panRole
    [roles]="['admin']"
    action
    icon="add"
    color="primary"
    [disabled]="isHandlingProviders()"
    (click)="newKioskProviderModal.show()"
  ></app-pan-button>
</app-pan-section-header>

<ag-grid-angular
  [rowData]="allBranchAliases()"
  [columnDefs]="kioskOrganizationColumns"
  [gridOptions]="kioskOrganizationTable"
></ag-grid-angular>
